import { jsx as _jsx } from "react/jsx-runtime";
import { LL_H_C } from '@nu-art/thunderstorm-frontend';
import { isWorkHubTabGroup } from '@nu-art/work-hub-shared';
import './Component_WorkHub_Header.scss';
import { Component_WorkHub_Tab } from './renderers/Component_WorkHub_Tab/Component_WorkHub_Tab.js';
import { Component_WorkHub_TabGroup } from './renderers/Component_WorkHub_TabGroup/Component_WorkHub_TabGroup.js';
export const Component_WorkHub_Header = (props) => {
    return _jsx(LL_H_C, { className: 'c__work-hub-header', children: props.items.map(item => {
            if (isWorkHubTabGroup(item))
                return _jsx(Component_WorkHub_TabGroup, { group: item, selectedTabId: props.selectedTabId }, item.groupKey);
            return _jsx(Component_WorkHub_Tab, { tab: item, selected: item.id === props.selectedTabId }, item.id);
        }) });
};
//# sourceMappingURL=Component_WorkHub_Header.js.map